<template>
  <div class="note" style="margin-bottom: 40px;">
      <div>
        <span><b>{{currentNote.Time}} {{currentNote.UserFullName}}</b></span><span> ({{currentNote.UserType}})</span>
      </div>
      <textarea ref="elText" rows="1" :class="['txtNote', isTopNote ? 'topNote': '' ]" v-model="currentNote.Info"></textarea>
      <div class="filesList" v-if="currentNote.Attachments">
        <div v-for="file in currentNote.Attachments">
          <v-icon @click="removeFile(file)" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'מחק קובץ' }">delete</v-icon>
          <a target="_blank" :href="file.FileUrl">{{file.FileName}}</a>
        </div>
      </div>
      <div v-if="showProgress">מעלה קובץ ...</div>
      <div class="noteCtrls">
        <div v-if="error" class="error" style="text-align: right;">{{error}}</div>
        <Recorder @record:start="" style="float:right;"></Recorder>
        <span v-if="$root.isContractor || $root.isInspector" style="font-weight: bold;color:red;">
          &nbsp;
          <input type="checkbox" v-model="isTopNote" class="w3-check"> פיקוח עליון
        </span>
        <label class="file-select">
          <v-icon right class="btnIcon mr-2" v-tooltip:bottom="{ html: 'העלאת קובץ' }">attachment</v-icon>
          <input type="file" @change="upload" />
        </label>
        <v-icon @click="save" class="btnIcon mr-2" v-tooltip:bottom="{ html: 'שמירה' }">save</v-icon>
        <v-icon @click="cancel" class="btnIcon mr-2 ml-2" v-tooltip:bottom="{ html: 'ביטול' }">cancel</v-icon>
      </div>
  </div>
</template>
<script>
  import { db, storage } from '../firebase';
  import Recorder from './Recorder';

  export default {
    name: 'NoteEditor',
    components: { Recorder },
    props: ['noteData', 'index', 'date', 'time'],
    data() {
      return {
        isShow: false,
        isEdit: false,
        isTopNote: false,
        isRecording: false,
        audioObj: null,
        showFile: false,
        showProgress: false,
        //time: '',
        error: '',
        page: '',
        currentNote: {
          '.key': '',
          UserKey: '',
          UserFullName: '',
          UserType: '',
          Date: '',
          Time: '',
          Weather: '',
          Info: '',
          Attachments: [],
          Record: ''
        },
      }
    },
    created() {
      this.$Log("Vue [NoteEditor] is created ...");
    },
    ready() {
      this.$Log("Vue [NoteEditor] is ready ...");
    },
    mounted() {
      this.$Log("Vue [NoteEditor] is mounted ...");
      var vm = this;
      //this.time;
      //vm.$GetWeather('e4987093d55bc5ea51a92cc175129921', vm.location.lat, vm.location.lng, function (error, data) {
      //  if (!error) {
      //    vm.time = vm.$moment(vm.$root.weather.currently.time * 1000).format('HH:mm');
      //  }
      //});

      if (this.noteData != undefined) {
        this.currentNote = this.noteData;
      }
      else {
        this.currentNote.Date = this.date; //"DD/MM/YYYY";//this.$moment(this.$root.timezone.time, 'YYYY-MM-DD HH:mm').format("DD/MM/YYYY");
        this.currentNote.Time = this.time; //"HH:mm";//this.$moment(this.$root.timezone.time, 'YYYY-MM-DD HH:mm').format("HH:mm");
        this.currentNote.UserKey = this.$root.user['.key'];
        this.currentNote.UserFullName = this.$root.user.FullName;
        this.currentNote.UserType = this.$root.user.Type;
        //this.currentNote.Weather = this.$root.weather.weatherObservation.clouds;
        this.currentNote.Attachments = null;
      }
    },
    updated() {
      this.$Log("Vue [NoteEditor] is updated ...");
    },
    computed: {
      txtId() {
        return 'txt' + this.index;
      },
      hasInfo() {
        return this.currentNote.Info.trim().length;
      }
    },
    watch: {
      hasInfo(val) {
        if (val) {
          this.error = "";
        }
      },
      isRecording(val) {
        if (val) {

        }
      },
    },
    methods: {
      upload(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        var vm = this;

        var file = files[0];
        var image = new Image();
        var reader = new FileReader();

        reader.onload = (ev) => {
          vm.logoUrl = ev.target.result;
        };
        reader.readAsDataURL(file);

        vm.showFile = true;

        var storageRef = storage.ref('attachments/' + file.name);

        var task = storageRef.put(file);

        //this.currentNote.Attachments = null;
        if (vm.currentNote.Attachments == null) {
          vm.currentNote.Attachments = [];
        }

        var attachment = { Type: "File", FileName: file.name, FileUrl: '' };

        task.on('state_changed',
          function progress(snap) {
            //vm.percent = (snap.bytesTransferred / snap.totalBytes) * 100;
            vm.showProgress = true;
          },
          function error(err) {
            vm.showFile = false;
            vm.showProgress = false;
          },
          function complete() {
            attachment.FileUrl = task.snapshot.downloadURL;
            vm.currentNote.Attachments.push(attachment);
            vm.showFile = true;
            vm.showProgress = false;
          }
        );
      },
      removeFile(file) {
        //this.currentNote.Attachments
      },
      save() {
        if (!this.hasInfo) {
          this.error = "* חסר נתונים! לא ניתן לשמור!!";
        }
        else {

          if (this.currentNote.Attachments == null) {
            this.currentNote.Attachments = [];
          }

          if (this.audioObj && this.audioObj != "ERROR") {
            this.currentNote.Attachments.push(this.audioObj);
          }

          if (this.currentNote['.key'] == "") {
            this.insert();
          }
          else {
            this.update();
          }
        }
      },
      insert() {
        var vm = this;
        //var splittedNote = this.currentNote.Info.split("\n");
        //console.log(splittedNote);
        //var noteText = this.currentNote.Info.replace("\n", "<br/>");
        //this.currentNote.Info = this.currentNote.Info.replace("\n", "\\\n");
        //return;
        var note = {
          UserKey: vm.currentNote.UserKey,
          UserFullName: vm.currentNote.UserFullName,
          UserType: vm.currentNote.UserType,
          Date: vm.currentNote.Date,
          Time: vm.currentNote.Time,
          //Weather: this.currentNote.Weather,
          Info: vm.isTopNote ? "[פיקוח עליון]\n" + vm.currentNote.Info : vm.currentNote.Info,
          Attachments: vm.currentNote.Attachments,
          IsGeneral: vm.$root.isNewGeneralNote,
          IsInfo: vm.$root.isNewInfoNote,
          IsTopNote: vm.isTopNote,
          Record: vm.audioObj
        };

        if (this.$root.activeDiaryPage.PageKey != null) {
          var pagePath = "DiaryPages/" + vm.$root.activeDiaryPage.PageKey + "/Notes";
          var pagesRef = db.ref(pagePath);
          pagesRef.push(note).then((snap) => {
            vm.$parent.loadPage();
          });
        }
        else {
          var notes = [];
          notes.push(note);
          var page = {
            Date: vm.currentNote.Date,
            Notes: notes,
            //Weather: this.currentNote.Weather
            Weather: vm.$parent.page.Weather
          }
          var pagesRef = db.ref("DiaryPages");
          //pagesRef.push(page);
          pagesRef.push(page).then((snap) => {
            const pgKey = snap.key;
            vm.$root.activeDiaryPage.PageKey = pgKey;
            var diariesPagesRef = db.ref('Diaries/' + vm.$route.params.diaryKey + '/Pages');
            diariesPagesRef.push({ Date: vm.date, PageKey: pgKey }).then((snapDP) => {
              //refresh page notes
              if (vm.$parent.isEdit) {
                vm.$parent.$parent.loadPage();
              }
              else {
                vm.$parent.loadPage();
              }
              vm.cancel();
            });
          })
        }
      },
      update() {
        var vm = this;
        var note = {
          //'.key': vm.index,
          UserKey: vm.currentNote.UserKey,
          UserFullName: vm.currentNote.UserFullName,
          UserType: vm.currentNote.UserType,
          Date: vm.currentNote.Date,
          Time: vm.currentNote.Time,
          //Weather: vm.currentNote.Weather,
          Info: vm.isTopNote ? "[פיקוח עליון]\n" + vm.currentNote.Info : vm.currentNote.Info,
          IsGeneral: vm.currentNote.IsGeneral,
          IsInfo: vm.currentNote.IsInfo,
          IsTopNote: vm.isTopNote,
          Record: vm.audioObj
        };

        if (vm.currentNote.Attachments != undefined && vm.currentNote.Attachments.length > 0) {
          if (vm.noteData.Attachments == null) {
            note.Attachments = { 0: vm.currentNote.Attachments };
          }
          else {
            note.Attachments = vm.currentNote.Attachments;
          }
        }

        if (vm.$root.activeDiaryPage.PageKey != null) {
          var notePath = "DiaryPages/" + vm.$root.activeDiaryPage.PageKey + "/Notes/" + vm.currentNote['.key'];
          var noteRef = db.ref(notePath);
          noteRef.set(note).then((snap) => {
            //refresh page notes
            if (vm.$parent.isEdit) {
              vm.$parent.$parent.loadPage();
            }
            else {
              vm.$parent.loadPage();
            }
            vm.cancel();
          });
        }
        else {
          vm.cancel();
        }
      },
      cancel() {
        if (this.currentNote['.key'] == "") {
          //if ((this.noteData) && (this.noteData['.key'] == this.$parent.selectedNoteKey)) {
          //  this.$parent.selectedNoteKey = "";
          //}
          this.$root.isNewNote = false;
          this.$root.isNewGeneralNote = false;
          this.$root.isNewInfoNote = false;
        }
        else {
          //if ((this.noteData) && (this.noteData['.key'] == this.$parent.selectedNoteKey)) {
          //  this.$parent.selectedNoteKey = "";
          //}
          //this.$root.isEditNote = false;
          this.$parent.isEdit = false;
          this.$root.isNewGeneralNote = false;
          this.$root.isNewInfoNote = false;
        }
      }
    }
  }

</script>
<style>

  .time {
    background-color: red;
  }

  .txtNote {
    width: 100%;
    height: 120px;
    border: none;
    line-height: 32px;
    padding: 0px;
    margin: 0px;
    background-color: rgba(255,255,0,0.1)
  }

  .filesList {
    padding: 0px;
    margin: 0px;
  }

    .filesList > a {
      text-decoration: underline;
      cursor: pointer;
      max-width: 300px;
      overflow-x: hidden;
      width: 250px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

  .lnkUpload {
    text-decoration: underline;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// NoteEditor.vue?6b3d1753